// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1snaw","title":"FrontImage_title__2mluA"};